export const MODEL_ROUTE = '/patient-images';
